import { withAuth } from 'hocs/auth/with-auth';
import { AgoraVideoCall } from './agora-video-call';

const WrappedAgoraVideoCall = withAuth(AgoraVideoCall, true);

export { WrappedAgoraVideoCall as AgoraVideoCall };
